import { Star } from "./Star";
import { getCssVar } from "../../types/theme.ts";
import s from "./style.module.scss";

type StarRatingValueProps = {
  rating?: string;
  starColor?: string;
};

export const StarRatingValue = ({
  rating,
  starColor = getCssVar("color_rating_star_icon"),
}: StarRatingValueProps) => {
  return (
    <div className={s.starRatingValue}>
      {Array.from({ length: 5 }, (_, index) => {
        const integerPart = Math.floor(parseFloat(rating as string));
        const hasHalf = parseFloat(rating as string) % 1 !== 0;

        if (index < integerPart) {
          return <Star key={index} type="full" starColor={starColor} />;
        } else if (index === integerPart && hasHalf) {
          return <Star key={index} type="half" starColor={starColor} />;
        } else {
          return <Star key={index} type="empty" starColor={starColor} />;
        }
      })}
    </div>
  );
};
